import { Text, StyleSheet, View } from "@react-pdf/renderer"

const dataStyles = StyleSheet.create({
	view: {
		marginBottom: 10,
		fontSize: 10,
	},
	label: {
		color: "#1B1464",
	},
})

type DataViewProps = {
	label?: string
	value: string
	unit?: string
	styles?: any
	valueStyles?: any
}

// Data specific component
export const DataView = ({
	label,
	value,
	unit,
	styles = null,
	valueStyles = null,
}: DataViewProps) => {
	return (
		<View style={[dataStyles.view, styles]}>
			<Text style={[dataStyles.label]}>{label && label.length > 0 ? label : " "}</Text>
			<Text style={valueStyles}>
				{value && value.toString().length > 0 ? value : "-"}
				{unit && <Text style={{ marginLeft: 10 }}>{unit}</Text>}
			</Text>
		</View>
	)
}
